import { useFormContext } from "react-hook-form";

import { useFormFieldContext } from "./form-field-context";
import { useFormItemContext } from "./form-item-context";

export const useFormField = () => {
  const { name } = useFormFieldContext();
  const { id } = useFormItemContext();
  const { getFieldState, formState } = useFormContext();

  return {
    id,
    name,
    formItemId: `${id}-form-item`,
    formDescriptionId: `${id}-form-item-description`,
    formMessageId: `${id}-form-item-message`,
    ...getFieldState(name, formState),
  };
};
